<template>
    <div class="container">
        <div class="back" @click="goBack"><i class="el-icon-back"></i> 返回</div>
        <el-form ref="form" :model="form" :rules="rules" label-width="180px" class="package-form">
            <el-form-item label="套餐名称" prop="name">
                <el-input v-model.trim="form.name" maxlength="100" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="套餐类型" prop="package_type">
                <el-radio-group v-model="form.package_type">
                    <el-radio :label="1">通信+云存储</el-radio>
                    <el-radio :label="2">纯云存储</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="服务时长" prop="service_time">
                <div class="duration-row">
                    <el-input-number v-model="form.service_time" :min="1" :precision="0"></el-input-number>
                    <el-select v-model="form.service_time_unit" placeholder="单位">
                        <el-option label="DAY" value="DAY"></el-option>
                        <el-option label="WEEK" value="WEEK"></el-option>
                        <el-option label="MONTH" value="MONTH"></el-option>
                        <el-option label="YEAR" value="YEAR"></el-option>
                    </el-select>
                </div>
            </el-form-item>
            <el-form-item label="云文件保留天数" prop="file_time">
                <el-input-number v-model="form.file_time" :min="0" :precision="0"></el-input-number>
            </el-form-item>
            <el-form-item label="免费试用">
                <el-switch v-model="form.is_trial" :active-value="1" :inactive-value="0"></el-switch>
            </el-form-item>
            <el-form-item v-if="form.is_trial === 1" label="试用天数" prop="trial_days">
                <el-input-number v-model="form.trial_days" :min="1" :precision="0"></el-input-number>
            </el-form-item>
            <el-form-item label="标签">
                <el-select v-model="form.tag">
                    <el-option label="无标签" value=""></el-option>
                    <el-option label="推荐" value="recommended"></el-option>
                    <el-option label="最划算" value="best_value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="排序权重">
                <el-input-number v-model="form.sort_order" :min="0" :precision="0"></el-input-number>
                <span class="help-text">数字越小越靠前</span>
            </el-form-item>
            <el-form-item label="上架区域">
                <el-select v-model="form.regions" multiple filterable allow-create default-first-option
                    placeholder="请选择或输入区域码" style="width: 420px">
                    <el-option label="US" value="US"></el-option>
                    <el-option label="EU" value="EU"></el-option>
                    <el-option label="CN" value="CN"></el-option>
                </el-select>
                <div class="help-text">可多选区域码；不选择表示暂不指定区域，App 端无法按区域命中。</div>
            </el-form-item>

            <el-form-item label="套餐说明">
                <el-input v-model="form.explain" type="textarea" :rows="4" maxlength="500" show-word-limit></el-input>
            </el-form-item>

            <el-form-item v-if="form.is_trial === 0" label="价格" prop="prices">
                <div class="dynamic-list">
                    <div v-for="(item, index) in form.prices" :key="index" class="price-row">
                        <div style="display:flex;width:200px;flex-direction:column;gap:5px">
                            <span style="color:#606266;font-size:12px">币种</span>
                            <el-select v-model="item.currency" filterable placeholder="请选择币种">
                                <el-option v-for="currency in currencyList" :key="currency.code" :label="currency.name"
                                    :value="currency.code"></el-option>
                            </el-select>
                        </div>
                        <div style="display:flex;width:180px;flex-direction:column;gap:5px">
                            <span style="color:#606266;font-size:12px">原价</span>
                            <el-input-number v-model="item.price" :min="0" :precision="2" placeholder="请输入原价"></el-input-number>
                        </div>
                        <div style="display:flex;width:180px;flex-direction:column;gap:5px">
                            <span style="color:#606266;font-size:12px">售价</span>
                            <el-input-number v-model="item.sale_price" :min="0" :precision="2" placeholder="请输入售价"></el-input-number>
                        </div>
                        <el-button v-if="form.prices.length > 1" style="margin-top:22px" type="danger" size="mini" @click="removePrice(index)">删除</el-button>
                    </div>
                    <el-button type="primary" plain size="small" @click="addPrice">添加币种价格</el-button>
                </div>
            </el-form-item>

            <el-form-item label="功能特性">
                <div class="dynamic-list">
                    <div v-for="(item, index) in form.ext_features" :key="index" class="feature-row">
                        <el-select v-model="item.item_key" filterable placeholder="选择功能特性"
                            @change="onFeatureKeyChange(item)">
                            <el-option v-for="feature in featureOptions" :key="feature.item_key"
                                :label="feature.item_name + '（' + feature.item_key + '）'"
                                :value="feature.item_key"></el-option>
                        </el-select>
                        <el-select v-if="item.item_key === '4g_package'" v-model="item.item_value" filterable clearable
                            placeholder="选择4G套餐">
                            <el-option v-for="pack in fourGPackageOptions" :key="pack.code"
                                :label="pack.name + '（' + pack.code + '）'" :value="pack.code"></el-option>
                        </el-select>
                        <el-select v-else-if="item.item_key === 'cloud_storage'" v-model="item.item_value" filterable
                            clearable placeholder="选择云存储套餐">
                            <el-option v-for="pack in cloudPackageOptions" :key="pack.code"
                                :label="pack.name + '（' + pack.code + '）'" :value="pack.code"></el-option>
                        </el-select>
                        <el-input v-else v-model.trim="item.item_value" placeholder="功能值或展示文案"></el-input>
                        <el-input-number v-model="item.sort_order" :min="0" :precision="0"></el-input-number>
                        <el-button type="danger" size="mini" @click="removeFeature(index)">删除</el-button>
                    </div>
                    <el-button type="primary" plain size="small" @click="addFeature">添加功能特性</el-button>
                    <div class="help-text">4g_package 的值请选择 4G 套餐，cloud_storage 的值请选择云存储套餐；其余功能项直接填写功能值或展示文案。</div>
                </div>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" :loading="submitting" @click="submit">创建套餐</el-button>
                <el-button @click="goBack">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import api from '../../../axios/pack'
import commonApi from '../../../axios/api'

export default {
    name: 'HuntingPackageCreate',
    data() {
        const validatePrices = (rule, value, callback) => {
            if (this.form.is_trial === 1) return callback()
            if (!value.length) return callback(new Error('请至少添加一个币种价格'))
            const currencies = value.map(item => item.currency)
            if (currencies.some(item => !item)) return callback(new Error('请选择币种'))
            if (new Set(currencies).size !== currencies.length) return callback(new Error('币种不可重复'))
            if (value.some(item => item.price === undefined || item.price === null || item.sale_price === undefined || item.sale_price === null)) {
                return callback(new Error('请填写原价和售价'))
            }
            callback()
        }
        const validateTrialDays = (rule, value, callback) => {
            if (this.form.is_trial === 1 && (!value || value <= 0)) return callback(new Error('请输入大于 0 的试用天数'))
            callback()
        }
        return {
            featureOptions: [],
            fourGPackageOptions: [],
            cloudPackageOptions: [],
            currencyList: [],
            submitting: false,
            form: {
                name: '',
                package_type: 1,
                service_time: 1,
                service_time_unit: 'MONTH',
                file_time: 0,
                is_trial: 0,
                trial_days: 0,
                tag: '',
                sort_order: 0,
                regions: [],
                explain: '',
                prices: [{ currency: 'USD', price: null, sale_price: null }],
                ext_features: []
            },
            rules: {
                name: [{ required: true, message: '请输入套餐名称', trigger: 'blur' }],
                package_type: [{ required: true, message: '请选择套餐类型', trigger: 'change' }],
                service_time: [{ required: true, message: '请输入服务时长', trigger: 'blur' }],
                file_time: [{ required: true, message: '请输入云文件保留天数', trigger: 'blur' }],
                trial_days: [{ validator: validateTrialDays, trigger: 'change' }],
                prices: [{ validator: validatePrices, trigger: 'change' }]
            }
        }
    },
    methods: {
        loadCurrencies() {
            commonApi.CurrencyList({ page: 1, limit: 200 }).then(res => {
                if (res.data.code == 200) {
                    this.currencyList = res.data.data.data || []
                    return
                }
                this.$message.error('获取币种失败：' + res.data.msg)
            })
        },
        loadFeatureOptions() {
            api.HuntingPackageFeatureDictAll({}).then(res => {
                if (res.data.code == 200) {
                    this.featureOptions = res.data.data.data || []
                    return
                }
                this.$message.error('获取功能特性失败：' + res.data.msg)
            })
        },
        loadFourGPackageOptions() {
            api.FourGPackageList({
                page: 1,
                limit: 1000,
                status: JSON.stringify([0, 1, 2]),
                order_action: 1
            }).then(res => {
                if (res.data.code == 200) {
                    const list = res.data.data.data || []
                    this.fourGPackageOptions = list.filter(item => item && item.code)
                    return
                }
                this.$message.error('获取4G套餐失败：' + res.data.msg)
            })
        },
        loadCloudPackageOptions() {
            api.PackageList({
                page: 1,
                limit: 1000,
                status: JSON.stringify([0, 1, 2]),
                is_event: -1,
                order_action: 1
            }).then(res => {
                if (res.data.code == 200) {
                    const list = res.data.data.data || []
                    this.cloudPackageOptions = list.map(item => item.SetMeal || item).filter(item => item && item.code)
                    return
                }
                this.$message.error('获取云存储套餐失败：' + res.data.msg)
            })
        },
        onFeatureKeyChange(item) {
            item.item_value = ''
        },
        addPrice() {
            this.form.prices.push({ currency: '', price: null, sale_price: null })
        },
        removePrice(index) {
            this.form.prices.splice(index, 1)
        },
        addFeature() {
            this.form.ext_features.push({ item_key: '', item_value: '', sort_order: this.form.ext_features.length })
        },
        removeFeature(index) {
            this.form.ext_features.splice(index, 1)
        },
        validateFeatures() {
            const invalid = this.form.ext_features.some(item => !item.item_key || !item.item_value)
            if (invalid) {
                this.$message.error('请选择功能特性并填写特性值')
                return false
            }
            const keys = this.form.ext_features.map(item => item.item_key)
            if (new Set(keys).size !== keys.length) {
                this.$message.error('同一功能特性不可重复关联')
                return false
            }
            return true
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid || !this.validateFeatures()) return
                this.submitting = true
                const payload = {
                    ...this.form,
                    service_time: Number(this.form.service_time),
                    file_time: Number(this.form.file_time),
                    trial_days: this.form.is_trial === 1 ? Number(this.form.trial_days) : 0,
                    sort_order: Number(this.form.sort_order),
                    regions: this.form.regions,
                    prices: this.form.is_trial === 1 ? [] : this.form.prices.map(item => ({
                        currency: item.currency,
                        price: Number(item.price),
                        sale_price: Number(item.sale_price)
                    })),
                    ext_features: this.form.ext_features.map(item => ({
                        item_key: item.item_key,
                        item_value: item.item_value,
                        sort_order: Number(item.sort_order)
                    }))
                }
                api.HuntingPackageCreate(payload).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success('套餐创建成功')
                        this.goBack()
                        return
                    }
                    this.$message.error('创建失败：' + res.data.msg)
                }).finally(() => {
                    this.submitting = false
                })
            })
        },
        goBack() {
            this.$router.push('/iot/huntingpack')
        }
    },
    created() {
        this.loadCurrencies()
        this.loadFeatureOptions()
        this.loadFourGPackageOptions()
        this.loadCloudPackageOptions()
    }
}
</script>

<style scoped>
.back { margin-bottom: 16px; width: 60px; cursor: pointer; font-size: 14px; }
.package-form { max-width: 900px; }
.duration-row, .price-row, .feature-row { display: flex; gap: 10px; align-items: center; }
.duration-row .el-select { width: 150px; }
.dynamic-list { width: 100%; }
.price-row, .feature-row { margin-bottom: 10px; }
.price-row .el-select, .feature-row .el-select { width: 240px; }
.feature-row .el-input { flex: 1; }
.help-text { color: #909399; margin-left: 10px; font-size: 12px; }
.dynamic-list .help-text { margin: 8px 0 0; }
</style>
